import React from 'react';
import { Col, InputGroup, InputGroupText, FormGroup, Input, Label, Row } from 'reactstrap';
import { getOptions } from '../../utils';

class Name extends React.Component {

    constructor(props) {
        super(props);
        this.state = { ...props }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps && nextProps.modifiedDate !== prevState.modifiedDate)
            return { ...nextProps };

        return null;
    }

    firstNameIsValid = () => this.state.firstName && this.state.firstName.length > 0;
    lastNameIsValid = () => this.state.lastName && this.state.lastName.length > 0;

    handleOnLocalChange = (event) => {
        const { target: { name, value } } = event
        this.setState({ [name]: value }, this.handleOnChange);
    };

    handleOnChange = () => {
        const { toggleContactNameValidState } = this.props;
        if (this.firstNameIsValid() && this.lastNameIsValid())
            toggleContactNameValidState(true);
        else {
            toggleContactNameValidState(false);
        }
        const name = (({ generations, properTitles, onChange, ...others }) => ({ ...others }))(this.state);
        this.props.onChange(name);
    }

    render() {

        const { fromContactDemographics } = this.props;

        // I put this here for lack of a better place to put it. It could be broken out to its own 
        // component but it's only 2 fields and I am only showing it if the route to the component 
        // has gone through the contacts demographic tab as requested - BW

        const showOrganizationAndTitle = (fromContactDemographics && <Row>
            <Col>
                <FormGroup>
                    <Label>Company/Organization:</Label>
                    <Input
                        name='company'
                        type='text'
                        onChange={this.handleOnLocalChange}
                        value={this.state.company || ''} />
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <Label>Title:</Label>
                    <Input
                        name='title'
                        type='text'
                        onChange={this.handleOnLocalChange}
                        value={this.state.title || ''} />
                </FormGroup>
            </Col>
        </Row>)

        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <Label>*First Name:</Label>
                        <InputGroup>
                            <InputGroupText>
                                <Input addon name='properTitle' type="select" className='bg-transparent border-0 p-0 h-100' onChange={this.handleOnLocalChange} value={this.state.properTitle || ''}>
                                    <option key={null} value={null}></option>
                                    {getOptions(this.props.properTitles, false, true)}
                                </Input>
                            </InputGroupText>
                            <Input
                                name='firstName'
                                invalid={!this.firstNameIsValid()}
                                type='text'
                                onChange={this.handleOnLocalChange} value={this.state.firstName || ''} />
                        </InputGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Label>Middle Name:</Label>
                            <Input
                                name='middleName'
                                type='text'
                                onChange={this.handleOnLocalChange}
                                value={this.state.middleName || ''} />
                        </FormGroup>
                    </Col>
                    <Col>
                        <Label>*Last Name:</Label>
                        <InputGroup>
                            <Input
                                name='lastName' type='text'
                                invalid={!this.lastNameIsValid()}
                                onChange={this.handleOnLocalChange}
                                value={this.state.lastName || ''} />
                                <InputGroupText>
                                    <Input addon name='generation' type='select' id='selectGeneration' className='bg-transparent border-0 p-0 h-100' onChange={this.handleOnLocalChange} value={this.state.generation || ''}>
                                        <option key={null} value={null}></option>
                                        {getOptions(this.props.generations, false, true)}
                                    </Input>
                                </InputGroupText>
                        </InputGroup>
                    </Col>
                </Row>
                {showOrganizationAndTitle}
            </React.Fragment>
        );
    }
}

export default Name;